export default {
    wrapper: {
        borderBottom: "thin solid #e0e0e0",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        flexWrap: "wrap",
        textAlign: "center"
    },
    title: {
        fontSize: "28px",
        fontWeight: 300,
        lineHeight: 2.07,
        letterSpacing: "-1.1px",
        color: "#417505",
        "&.error": {
            color: "#f44336"
        }
    },
    subtitle: {
        fontSize: "16px",
        fontWeight: "normal",
        lineHeight: 1.25,
        color: "#5b5b5b",
        marginBottom: "32px"
    }
}